const MapMarkerIcon = ({ width = "32px", height = "32px", color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    width={width}
    height={height}
  >
    <g>
      <path
        d="M16 2a11.01 11.01 0 0 0-8.44 18.05L16 30l8.44-9.95.34-.45A11.01 11.01 0 0 0 16 2Zm0 15a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default MapMarkerIcon;
